// JavaScript Document

$(document).ready(function() {
	/* navigation */
	document.addEventListener('click',function(e){
		// Hamburger menu
		if(e.target.classList.contains('hamburger-toggle')){
			e.target.children[0].classList.toggle('active');
		}
	});
	$(".navbar-toggler").click(function () {
		$("html").toggleClass("nav-menu-open overflow-hidden");
		$(".header").toggleClass("nav-menu-open");
		$(".main-content-wrapper-section").toggleClass("nav-menu-open");
	
		// setTimeout(() => {
		// 	var header_height = $(".header").innerHeight();
		// 	$(".navbar .navbar-collapse.show").css({"height": "calc(100vh - "+ header_height +"px)"});
		// }, 500);
	});
	/* navigation */

	/* latest-updates-carousel */
	$('.latest-updates-carousel').slick({
		autoplay: true,
		autoplaySpeed: 0,
		speed: 5000,
		dots: false,
		arrows: false,
		swipe: false,
		variableWidth: true,
		cssEase: 'linear',
		pauseOnFocus: false,
		pauseOnHover: false,
	});
	/* latest-updates-carousel */

	/* our-products-carousel */
	$('.our-products-carousel').slick({
		dots: false,
		arrows: true,
		infinite: true,
		speed: 1000,
		slidesToShow: 3,
		slidesToScroll: 1,
		prevArrow: '<div class="slick-prev slick-arrow"><svg width="16" height="16" viewBox="0 0 16 16" fill="#736760" stroke="#736760" xmlns="http://www.w3.org/2000/svg"><path d="M7.81836 0.5C7.74741 0.500668 7.68556 0.517317 7.62402 0.560547L7.5625 0.613281L0.614258 7.56152C0.561086 7.61569 0.535413 7.65782 0.523438 7.68652V7.6875C0.508317 7.72385 0.5 7.7639 0.5 7.81152C0.500028 7.85913 0.508632 7.89825 0.523438 7.93359V7.93457C0.535305 7.96304 0.560735 8.00538 0.614258 8.05957L7.56836 15.0078C7.65972 15.0981 7.73833 15.124 7.82129 15.124C7.90199 15.1239 7.97415 15.0994 8.05762 15.0137L8.0625 15.0088L8.11426 14.9482C8.15636 14.8886 8.17088 14.8306 8.1709 14.7656C8.1709 14.701 8.15613 14.6433 8.11426 14.584L8.0625 14.5234L1.70117 8.16211H15.1113C15.2334 8.16207 15.3057 8.12693 15.3662 8.06641H15.3672C15.4281 8.0055 15.4629 7.93257 15.4629 7.81055C15.4629 7.68853 15.4281 7.6156 15.3672 7.55469H15.3662C15.3057 7.49416 15.2334 7.45902 15.1113 7.45898H1.70117L8.05664 1.10352C8.11796 1.04216 8.14974 0.983763 8.16211 0.918945L8.16797 0.851562C8.16888 0.761613 8.14272 0.688031 8.0625 0.607422L8.06152 0.606445C7.98138 0.525858 7.90802 0.499224 7.81836 0.5Z"/></svg></div>',
  		nextArrow: '<div class="slick-next slick-arrow"><svg width="16" height="16" viewBox="0 0 16 16" fill="#736760" stroke="#736760" xmlns="http://www.w3.org/2000/svg"><path d="M8.14453 0.5C8.21548 0.500668 8.27733 0.517317 8.33887 0.560547L8.40039 0.613281L15.3486 7.56152C15.4018 7.61569 15.4275 7.65782 15.4395 7.68652V7.6875C15.4546 7.72385 15.4629 7.7639 15.4629 7.81152C15.4629 7.85913 15.4543 7.89825 15.4395 7.93359V7.93457C15.4276 7.96304 15.4022 8.00538 15.3486 8.05957L8.39453 15.0078C8.30318 15.0981 8.22456 15.124 8.1416 15.124C8.0609 15.1239 7.98874 15.0994 7.90527 15.0137L7.90039 15.0088L7.84863 14.9482C7.80653 14.8886 7.79201 14.8306 7.79199 14.7656C7.79199 14.701 7.80676 14.6433 7.84863 14.584L7.90039 14.5234L14.2617 8.16211H0.851562C0.729469 8.16207 0.657228 8.12693 0.59668 8.06641H0.595703C0.53483 8.0055 0.500002 7.93257 0.5 7.81055C0.5 7.68853 0.534835 7.6156 0.595703 7.55469H0.59668C0.657231 7.49416 0.729461 7.45902 0.851562 7.45898H14.2617L7.90625 1.10352C7.84494 1.04216 7.81315 0.983763 7.80078 0.918945L7.79492 0.851562C7.79401 0.761613 7.82017 0.688031 7.90039 0.607422L7.90137 0.606445C7.98151 0.525858 8.05487 0.499224 8.14453 0.5Z"/></svg></div>',
		responsive: [
		{
			breakpoint: 1200,
			settings: {
				slidesToShow: 3,
			}
		},
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
			}
		}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
	/* our-products-carousel */

/* Price Range Slider */

var maxPrice = parseInt($('.price-range-max').val());

if (isNaN(maxPrice)) return;

const params = new URLSearchParams(window.location.search);

var currentValue = parseFloat(params.get('filter.v.price.lte'));

// URL value (93.01) → Slider value (9301)
if (!isNaN(currentValue)) {
    currentValue = Math.round(currentValue * 100);
}

if (isNaN(currentValue) || currentValue <= 0) {
    currentValue = maxPrice;
}

$(".price-range-slider").slider({

    min: 0,
    max: maxPrice,
    value: currentValue,
    range: "min",

    create: function () {

        $('.price-range-value').text(
            (currentValue / 100).toFixed(2)
        );

        $('.price-max-input').val(
            (currentValue / 100).toFixed(2)
        );

    },

    slide: function (event, ui) {

        $('.price-range-value').text(
            (ui.value / 100).toFixed(2)
        );

        $('.price-max-input').val(
            (ui.value / 100).toFixed(2)
        );

    },

    stop: function () {

        $('#CollectionFiltersForm').submit();

    }

});
	/* range slider */

	/* filter toggle */
	$(".our-products-wrapper .our-products-sidebar .sidebar-burger").click(function(e){
		$(".our-products-wrapper .our-products-sidebar").toggleClass("open");
		e.preventDefault();
	});
	/* filter toggle */

	// Number Field Increase Decrease Start
	$(document).on("click", ".number-field .btn-plus", function (e) {
		if (!jQuery(e.target).hasClass("disabled")) {

			const isNegative = $(e.target).closest('.btn-minus').is('.btn-minus');
			const input = $(e.target).closest('.number-field').find('input');
			if (input.is('input')) {
				input[0][isNegative ? 'stepDown' : 'stepUp']()
			}
		}
	});

	$(document).on("click", ".number-field .btn-minus", function (e) {

		if (!jQuery(e.target).hasClass("disabled")) {

			const isNegative = $(e.target).closest('.btn-minus').is('.btn-minus');
			const input = $(e.target).closest('.number-field').find('input');
			if (input.is('input')) {
				input[0][isNegative ? 'stepDown' : 'stepUp']()
			}
		}

	});
	// Number Field Increase Decrease End

	/* responsive tabing */
	$(document).on('show.bs.tab', '.nav-tabs-responsive [data-bs-toggle="tab"]', function(e) {
		var $target = $(e.target);
		var $tabs = $target.closest('.nav-tabs-responsive');
		// var $current = $target.closest('li');
		var $current = $target.closest('li');
		var $parent = $current.closest('li.dropdown');
		$current = $parent.length > 0 ? $parent : $current;
		var $next = $current.next();
		var $prev = $current.prev();
		var updateDropdownMenu = function($el, position){
		  $el
			.find('.dropdown-menu')
			.removeClass('pull-xs-left pull-xs-center pull-xs-right')
			.addClass( 'pull-xs-' + position );
		};
	
		$tabs.find('>li').removeClass('next prev active');
		$prev.addClass('prev');
		$next.addClass('next');
		$prev.removeClass('active');
		$next.removeClass('active');
		$current.addClass('active');
		
		updateDropdownMenu( $prev, 'left' );
		updateDropdownMenu( $current, 'center' );
		updateDropdownMenu( $next, 'right' );
	});
	/* responsive tabing */

	// OFI Browser
	objectFitImages();
	// OFI Browser

	$(document).on('click', '.variant-option', function(e){

    e.preventDefault();

    var productCard = $(this).closest('.our-product-block');

    productCard.find('.variant-option').removeClass('active');

    $(this).addClass('active');

    var variantId = $(this).data('variant-id');

    productCard.find('.selected-variant-id').val(variantId);

    // Price update
    var variantPrice = $(this).data('price');

    productCard.find('.product-price').text(variantPrice);

});

});


    document.addEventListener('submit', async function(e){

        const form = e.target.closest('form[action="/cart/add"]');

        if(!form) return;

        e.preventDefault();

        const formData = new FormData(form);

        await fetch('/cart/add.js',{
            method:'POST',
            body:formData
        });

        sessionStorage.setItem('openCartDrawer', 'true');

        window.location.reload();

    });

    window.addEventListener('load', function() {

        if(sessionStorage.getItem('openCartDrawer') === 'true') {

            sessionStorage.removeItem('openCartDrawer');

            setTimeout(function(){

                document
                  .querySelector('cart-drawer-component')
                  ?.open();

            }, 150);

        }

    });